'use strict';

/**
 * Australian English — default product copy.
 * Add keys here first; mirror them in other locale files when translating.
 */
module.exports = {
  login: {
    trustLine:
      'Trusted by teams in regulated professions worldwide — wherever the hard conversations matter.',
    pitchTitle: 'Real conversations, before they\u2019re real.',
    pitchBody:
      'Practise the hard bits — the objection, the diagnosis, the difficult news — and get feedback while it still matters.',
    orgManagedSignIn: 'Sign-in is managed by your organisation.',
    orgOnAudirie: '{name} on Audirie',
    welcomeBack: 'Welcome back.',
    findYourWayIn: 'Let\u2019s find your way in.',
    startWithWorkEmail: 'Start with your work email — we\u2019ll take you the right way in.',
    workEmailTellsUs:
      'Your work email tells us how your organisation signs in. No password needed if they use single sign-on.',
    workEmail: 'Email address',
    continue: 'Continue',
    pickUpWhereLeftOff: 'Pick up right where you left off.',
    continueAs: 'Continue as {email}',
    singleSignOn: 'Single sign-on',
    singleSignOnWithOrg: 'Single sign-on · {orgName}',
    audiriePassword: 'Audirie password',
    useDifferentAccount: 'Use a different account',
    oneMoment: 'One moment…',
    checkingOrganisationSignIn: 'We’re checking how your organisation signs in.',
    whichOrgHeading: 'Which one are you signing in as?',
    belongsToMultipleOrgs: '{email} belongs to more than one organisation on Audirie.',
    yourOrganisation: 'Your organisation',
    useDifferentEmail: 'Use a different email',
    orgTakesItFromHere: '{name} takes it from here',
    yourOrgTakesItFromHere: 'Your organisation takes it from here',
    openingTheirSignIn:
      'We’re opening their sign-in page — you’ll finish there and come straight back. Nothing you enter on their page reaches us.',
    notYouStartAgain: 'Not you? Start again',
    verifiedGettingReady: 'You’re verified. Getting your practice space ready.',
    orgSignInComplete: '{name} sign-in is complete',
    accountNotReady: 'Your account is not ready yet',
    ssoWorkedButNeedsSetup:
      'Single sign-on worked, but your Audirie account still needs to be set up before you can enter.',
    noRoleAssigned:
      'Your account does not have a role assigned yet. Please contact your organisation administrator.',
    backToLogin: 'Back to login',
    orgDidntLetUsIn: '{name} didn\u2019t let us in',
    couldntCompleteSso: 'We couldn\u2019t complete single sign-on',
    orgSignInDeclined:
      'Your organisation’s sign-in service either declined the request or didn’t respond. Nothing is wrong with your Audirie account.',
    ifKeepsHappening:
      'If this keeps happening, send a note to your IT team — and let us know at support@audirie.com so we can help.',
    tryAgain: 'Try again',
    orgSignedInAsSomeoneElse: '{name} is signed in as someone else',
    differentAccountSignedIn: 'A different account is signed in',
    orgSignOnConnectedElsewhere:
      'Your organisation’s sign-on is still connected to another email address on this browser.',
    signOutCorporateFirst:
      'Sign out of that corporate account first, then come back and try again with the email you want to use.',
    enterPassword: 'Enter your password',
    change: 'change',
    password: 'Password',
    forgotPassword: 'Forgot your password?',
    signIn: 'Sign in',
    resetPassword: 'Reset your password',
    wellEmailLink: 'We’ll email you a link to choose a new one.',
    send: 'Send',
    cancel: 'Cancel',
    emailRequired: 'Email is required',
    emailAndPasswordRequired: 'Email and password are required',
    emailNotFound: 'That email was not found.',
    passwordIncorrect: 'Your password is incorrect.',
    ssoUnavailable: 'Single Sign-On is currently unavailable. Please sign in with your password.',
    popupBlocked:
      'Your browser blocked the sign-in window. Please allow pop-ups for this site, then refresh the page to continue.',
    couldNotLogIn:
      'Unfortunately we could not log you in. Please reach out to support@audirie.com if the problem persists.',
    resetEmailSent:
      'If the email address you gave is in our records, you will receive an email with a link to reset your password.',
    needValidEmail: 'Please give us a valid email.',
    mustRegisterFirst:
      'You must register with Audirie before you can complete this task. If you do not have a registration link, contact us at support@audirie.com',
    couldNotResetPassword:
      'We could not reset your password. Please try again. If this persists please contact us at support@audirie.com',
    maintenanceHeading: 'We’ll be right back',
    maintenanceDefaultBody:
      "We're doing a short maintenance update. Sign-in will be back shortly. Please try again in a few minutes.",
    maintenanceHint: 'This is a planned update — your account and data are safe.',
    checkAgain: 'Check again',
    softOutageBody:
      'We’re having trouble reaching the service right now. Please try again in a moment.'
  }
};
